import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Financials/Costs/Domain/commands-core';

@Component
export default class CostsCommands extends VueCqrs {

	invokeCreateExpenseAccountCommandV1(workspaceId: number, strategyId: string, expenseId: string, name: string, description: string, classification: string, subtotalId: string)
	{
		const cmd = new c.CreateExpenseAccountCommandV1(workspaceId, strategyId, expenseId, name, description, classification, subtotalId);
		this.$command(cmd, expenseId);
	}

	invokeDeleteExpenseAccountCommandV1(workspaceId: number, strategyId: string, expenseId: string)
	{
		const cmd = new c.DeleteExpenseAccountCommandV1(workspaceId, strategyId, expenseId);
		this.$command(cmd, expenseId);
	}

	invokeUpdateExpenseAccountCommandV1(workspaceId: number, strategyId: string, expenseId: string, name: string, description: string, classification: string, subtotalId: string)
	{
		const cmd = new c.UpdateExpenseAccountCommandV1(workspaceId, strategyId, expenseId, name, description, classification, subtotalId);
		this.$command(cmd, expenseId);
	}


	invokeCreateCostSubtotalCommandV1(workspaceId: number, strategyId: string, subtotalId: string, name: string)
	{
		const cmd = new c.CreateCostSubtotalCommandV1(workspaceId, strategyId, subtotalId, name);
		this.$command(cmd, subtotalId);
	}

	invokeDeleteCostSubtotalCommandV1(workspaceId: number, strategyId: string, subtotalId: string)
	{
		const cmd = new c.DeleteCostSubtotalCommandV1(workspaceId, strategyId, subtotalId);
		this.$command(cmd, subtotalId);
	}

	invokeRenameCostSubtotalCommandV1(workspaceId: number, strategyId: string, subtotalId: string, name: string)
	{
		const cmd = new c.RenameCostSubtotalCommandV1(workspaceId, strategyId, subtotalId, name);
		this.$command(cmd, subtotalId);
	}



	invokeUpdateCostAccountCommandV1(workspaceId: number, strategyId: string, costId: string, name: string, description: string, classification: string, subtotalId: string)
	{
		const cmd = new c.UpdateCostAccountCommandV1(workspaceId, strategyId, costId, name, description, subtotalId, classification);
		this.$command(cmd, costId);
	}


	invokeUpdateCostAccountClassificationCommandV1(workspaceId: number, strategyId: string, costId: string, classification: string)
	{
		const cmd = new c.UpdateCostAccountClassificationCommandV1(workspaceId, strategyId, costId, classification);
		this.$command(cmd, costId);
	}

	invokeUpdateCostAccountParentCommandV1(workspaceId: number, strategyId: string, costId: string, subtotalId: string)
	{
		const cmd = new c.UpdateCostAccountParentCommandV1(workspaceId, strategyId, costId, subtotalId);
		this.$command(cmd, costId);
	}
}
